import pick from "./pick.directive";
import pickOrigin from "./pick-origin.directive";
import pickTarget from "./pick-target.directive";
import pickTrigger from "./pick-trigger.directive";
import "./pick.scss";

export default angular
    .module("app.component.picklist", [])

    .directive("appPick", pick)

    .directive("appPickOrigin", pickOrigin)

    .directive("appPickTarget", pickTarget)

    .directive("appPickTrigger", pickTrigger).name;
